import { render, staticRenderFns } from "./school-index.vue?vue&type=template&id=ddafd4e6&scoped=true&"
import script from "./school-index.vue?vue&type=script&lang=js&"
export * from "./school-index.vue?vue&type=script&lang=js&"
import style0 from "./school-index.vue?vue&type=style&index=0&id=ddafd4e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddafd4e6",
  null
  
)

export default component.exports